import { v4 as uuidv4 } from 'uuid';

const rotation = [
    {   
        idSoft: uuidv4(),
        name: 'NONE',
        text: 'Aucun',
        value: 0,
        sizeAction: (width, height) => {
            return {width: width, height: height};
        },
        action: (size, styleObject) => {
            styleObject.width = size.width + "px";
            styleObject.height = size.height + "px";
            styleObject.top = "0px";
            styleObject.left = "0px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'RotateNoneFlipX',
        text: 'Retourner horizontalement',
        value: 4,
        sizeAction: (width, height) => {
            return {width: width, height: height};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateY(180deg)';
            styleObject.width = size.width + "px";
            styleObject.height = size.height + "px";
            styleObject.top = "0px";
            styleObject.left = "0px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'RotateNoneFlipY',
        text: 'Retourner verticalement',
        value: 6,
        sizeAction: (width, height) => {
            return {width: width, height: height};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateX(180deg)';
            styleObject.width = size.width + "px";
            styleObject.height = size.height + "px";
            styleObject.top = "0px";
            styleObject.left = "0px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'RotateNoneFlipXY',
        text: 'Retourner horizontalement et verticalement',
        value: 2,
        sizeAction: (width, height) => {
            return {width: width, height: height};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateX(180deg) rotateY(180deg)';
            styleObject.width = size.width + "px";
            styleObject.height = size.height + "px";
            styleObject.top = "0px";
            styleObject.left = "0px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'Rotate90FlipNone',
        text: 'Tourner de 90°',
        value: 1,
        sizeAction: (width, height) => {
            return {width: height, height: width};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateZ(90deg)';
            styleObject.width = size.height + "px";
            styleObject.height = size.width + "px";
            styleObject.top = ((size.height - size.width) / 2) + "px";
            styleObject.left = ((size.width - size.height) / 2) + "px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'Rotate90FlipX',
        text: 'Tourner de 90° et retourner horizontalement',
        value: 5,
        sizeAction: (width, height) => {
            return {width: height, height: width};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateZ(90deg) rotateY(180deg)';
            styleObject.width = size.height + "px";
            styleObject.height = size.width + "px";
            styleObject.top = ((size.height - size.width) / 2) + "px";
            styleObject.left = ((size.width - size.height) / 2) + "px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'Rotate90FlipY',
        text: 'Tourner de 90° et retourner verticalement',
        value: 7,
        sizeAction: (width, height) => {
            return {width: height, height: width};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateZ(90deg) rotateX(180deg)';
            styleObject.width = size.height + "px";
            styleObject.height = size.width + "px";
            styleObject.top = ((size.height - size.width) / 2) + "px";
            styleObject.left = ((size.width - size.height) / 2) + "px";
            return styleObject;
        }
    },
    {
        idSoft: uuidv4(),
        name: 'Rotate90FlipXY',
        text: 'Tourner de 90° et retourner horizontalement et verticalement',
        value: 3,
        sizeAction: (width, height) => {
            return {width: height, height: width};
        },
        action: (size, styleObject) => {
            styleObject.transform = 'rotateZ(90deg) rotateX(180deg) rotateY(180deg)';
            styleObject.width = size.height + "px";
            styleObject.height = size.width + "px";
            styleObject.top = ((size.height - size.width) / 2) + "px";
            styleObject.left = ((size.width - size.height) / 2) + "px";
            return styleObject;
        }
    },
]
export default rotation;
